import React, { useEffect, useState } from "react";
import apiClient from "../../utils/apiclient";

const DetailItem = ({ label, value }) => (
  <div className="rounded-lg border border-gray-200 bg-white p-2.5 shadow-sm">
    <div className="text-[10px] font-semibold uppercase tracking-wide text-gray-500">{label}</div>
    <div className="mt-1 break-words text-sm font-medium text-gray-800">{value ?? "-"}</div>
  </div>
);

const Index = () => {
  const [riders, setRiders] = useState([]);
  const [selectedRider, setSelectedRider] = useState("");

  const [batches, setBatches] = useState([]);
  const [selectedBatch, setSelectedBatch] = useState("");

  const [batchDetails, setBatchDetails] = useState(null);

  const [loadingRiders, setLoadingRiders] = useState(false);
  const [loadingBatches, setLoadingBatches] = useState(false);
  const [loadingOrders, setLoadingOrders] = useState(false);

  const [search, setSearch] = useState("");
  const [expandedOrderId, setExpandedOrderId] = useState(null);

  // Fetch Riders
  const fetchRiders = async () => {
    try {
      setLoadingRiders(true);

      const response = await apiClient.get(
        "/AllRiders?page=0&size=100"
      );

      setRiders(response.data.content || []);
    } catch (e) {
      console.error(e);
    } finally {
      setLoadingRiders(false);
    }
  };

  // Fetch Batches By Rider
  const fetchBatches = async (riderId) => {
    try {
      setLoadingBatches(true);

      const response = await apiClient.get(
        `/batches?page=0&size=100&search=${search}&riderId=${riderId}`
      );

      setBatches(response.data.content || []);
    } catch (e) {
      console.error(e);
    } finally {
      setLoadingBatches(false);
    }
  };

  // Fetch Orders By Batch
  const fetchBatchOrders = async (batchId) => {
    try {
      setLoadingOrders(true);

      const response = await apiClient.get(
        `/getBatchorders/${batchId}`
      );

const data = response.data;

// Merge subscription + one time orders
const combinedOrders = [
  ...(data.subscriptionOrders || []).map((order) => ({
    ...order,
    type: "SUBSCRIPTION",
  })),
  ...(data.oneTimeOrders || []).map((order) => ({
    ...order,
    type: "ONETIME",
  })),
].sort((a, b) => a.deliverySequence - b.deliverySequence);

setBatchDetails({
  ...data,
  allOrders: combinedOrders,
});
    } catch (e) {
      console.error(e);
    } finally {
      setLoadingOrders(false);
    }
  };

  useEffect(() => {
    fetchRiders();
  }, []);

  return (
    <div className="p-4">

      <div className="flex gap-4 mb-6">

        {/* Rider Dropdown */}
        <select
          className="border px-3 py-2 rounded w-72"
          value={selectedRider}
          onChange={(e) => {
            const riderId = e.target.value;

            setSelectedRider(riderId);
            setSelectedBatch("");
            setBatchDetails(null);

            if (riderId) {
              fetchBatches(riderId);
            } else {
              setBatches([]);
            }
          }}
        >
          <option value="">
            Select Rider
          </option>

          {riders.map((rider) => (
            <option
              key={rider.id}
              value={rider.id}
            >
              {rider.name} ({rider.number})
            </option>
          ))}
        </select>

        {/* Batch Dropdown */}
        <select
          className="border px-3 py-2 rounded w-72"
          disabled={!selectedRider}
          value={selectedBatch}
          onChange={(e) => {
            const batchId = e.target.value;

            setSelectedBatch(batchId);

            if (batchId) {
              fetchBatchOrders(batchId);
            }
          }}
        >
          <option value="">
            Select Batch
          </option>

          {batches.map((batch) => (
            <option
              key={batch.id}
              value={batch.id}
            >
              
              Batch #{batch.id} || created-on->{batch.localDate?batch.localDate:"-"} Created-At-> {batch.createdAt?batch.createdAt.split("T")[1].split(".")[0]:"-"} || updated-at-> {batch.updatedAt?batch.updatedAt.split("T")[1].split(".")[0]:"-"} || status->  {batch.status} ||
              distance-> {(batch.totalDistance/1000).toFixed(2)} km 
            </option>
          ))}
        </select>

      </div>

      {(loadingRiders ||
        loadingBatches ||
        loadingOrders) && (
        <div className="mb-4 font-semibold">
          Loading...
        </div>
      )}

      {batchDetails && (
        <>
          {/* Subscription Orders */}

         {batchDetails && (
  <>
    <h3 className="font-bold text-lg mb-2">
      Batch Orders
    </h3>

    <table className="w-full border">
      <thead className="bg-gray-100">
        <tr>
          <th>Seq</th>
          <th>Type</th>
          <th>ID</th>
          <th>Customer</th>
          <th>Meal / Restaurant</th>
          <th>Status</th>
          <th>Address</th>
          <th>Distance</th>
          <th>Created At</th>
          <th >Updated At</th>
        </tr>
      </thead>

      <tbody className="text-center">
        {batchDetails.allOrders?.map((order) => {
          const isExpanded = expandedOrderId === `${order.type}-${order.id}`;
          const orderKey = `${order.type}-${order.id}`;

          return (
            <React.Fragment key={orderKey}>
              <tr>
                <td>{order.deliverySequence}</td>

                <td>
                  {order.type === "SUBSCRIPTION"
                    ? "Subscription"
                    : "One Time"}
                </td>

                <td>
                  <button
                    type="button"
                    onClick={() => setExpandedOrderId(isExpanded ? null : orderKey)}
                    className="text-blue-700 font-semibold underline hover:text-blue-900"
                  >
                    {order.id}
                  </button>
                </td>

                <td>{order.userdetails?.name}</td>

                <td>
                  {order.type === "SUBSCRIPTION"
                    ? order.mealName
                    : order.restaurantName}
                </td>

                <td>
                  {order.type === "SUBSCRIPTION"
                    ? order.status
                    : order.orderStatus}
                </td>

                <td>{order.street}</td>

                <td>
                  {Number(order.distanceMeters/1000 || 0).toFixed(2)} km
                </td>
                <td className="text-center whitespace-nowrap">{order.createdAt.split("T")[1].split(".")[0]}</td>
                <td className="text-center whitespace-nowrap">{order.updatedAt.split("T")[1].split(".")[0]}</td>
              </tr>

              {isExpanded && (
                <tr>
                  <td colSpan={10} className="bg-gray-50 px-4 py-4">
                    <div className="rounded-xl border border-gray-200 bg-white p-4 shadow-sm">
                      <h2 className="text-base font-bold text-gray-900 mb-4">
                        {order.type === "SUBSCRIPTION" ? "Subscription Order" : "One-Time Order"} Details
                      </h2>

                      <div className="grid grid-cols-1 gap-3 md:grid-cols-2 xl:grid-cols-3">
                        <DetailItem label="Order ID" value={order.id} />
                        <DetailItem label="Public ID" value={order.publicId} />
                        {order.type === "SUBSCRIPTION" ? (
                          <>
                            <DetailItem label="Meal Name" value={order.mealName} />
                            <DetailItem label="Meal Plan Name" value={order.mealplanname} />
                            <DetailItem label="Meal Plan Type" value={order.mealplantype} />
                            <DetailItem label="Meal Plan Price" value={order.mealplanprice} />
                            <DetailItem label="Meal Description" value={order.mealDescription || "-"} />
                          </>
                        ) : (
                          <>
                            <DetailItem label="Restaurant Name" value={order.restaurantName} />
                            <DetailItem label="Price" value={order.price} />
                            <DetailItem label="Payment Method" value={order.paymentmethod} />
                            <DetailItem label="Discount Value" value={order.discountvalue} />
                            <DetailItem label="Discounted" value={order.discounted ? "Yes" : "No"} />
                          </>
                        )}
                        <DetailItem label="Start Time" value={order.startTime} />
                        <DetailItem label="End Time" value={order.endTime} />
                        <DetailItem label="Order Status" value={order.type === "SUBSCRIPTION" ? order.status : order.orderStatus} />
                        <DetailItem label="Order Date" value={order.orderdate} />
                        <DetailItem label="Delivery Sequence" value={order.deliverySequence} />
                        <DetailItem label="Distance" value={`${Number(order.distanceMeters/1000 || 0).toFixed(2)} km`} />
                        <DetailItem label="Estimated Delivery Time" value={order.estimatedDeliverytime} />
                        <DetailItem label="Customer Name" value={order.userdetails?.name} />
                        <DetailItem label="Customer Number" value={order.userdetails?.number || order.number} />
                        <DetailItem label="Street" value={order.street} />
                        <DetailItem label="State" value={order.state} />
                        <DetailItem label="City" value={order.city} />
                        <DetailItem label="Postal Code" value={order.postalCode} />
                        <DetailItem label="Country" value={order.country} />
                        <DetailItem label="Latitude" value={order.latitude} />
                        <DetailItem label="Longitude" value={order.longitude} />
                        <DetailItem label="Chef ID" value={order.chefid} />
                        <DetailItem label="Restaurant ID" value={order.restaurantid} />
                        <DetailItem label="Rider Name" value={order.riderDetails?.name} />
                        <DetailItem label="Rider Number" value={order.riderDetails?.number} />
                        <DetailItem label="OTP" value={order.otp || "-"} />
                        <DetailItem 
                          label={order.type === "SUBSCRIPTION" ? "Subscription Instruction" : "Delivery Instruction"} 
                          value={order.type === "SUBSCRIPTION" ? order.subscriptionOrderInstruction || "-" : order.deliveryInstruction || "No instructions"} 
                        />
                        <DetailItem label="Created At" value={order.createdAt} />
                        <DetailItem label="Updated At" value={order.updatedAt} />
                      </div>

                      {order.orderItems && order.orderItems.length > 0 && (
                        <div className="mt-4 rounded-xl border border-gray-200 bg-gray-50 p-3">
                          <div className="mb-2 text-xs font-semibold uppercase tracking-wide text-gray-500">Order Items</div>
                          <div className="space-y-2">
                            {order.orderItems.map((item, index) => (
                              <div key={`${item.id || index}`} className="grid grid-cols-1 gap-2 rounded-lg border border-gray-200 bg-white p-3 md:grid-cols-4">
                                <div>
                                  <div className="text-[10px] font-semibold uppercase tracking-wide text-gray-500">Name</div>
                                  <div className="text-sm text-gray-800">{item.name || "-"}</div>
                                </div>
                                <div>
                                  <div className="text-[10px] font-semibold uppercase tracking-wide text-gray-500">Count</div>
                                  <div className="text-sm text-gray-800">{item.count ?? "-"}</div>
                                </div>
                                <div>
                                  <div className="text-[10px] font-semibold uppercase tracking-wide text-gray-500">Price</div>
                                  <div className="text-sm text-gray-800">{item.price ?? "-"}</div>
                                </div>
                                <div>
                                  <div className="text-[10px] font-semibold uppercase tracking-wide text-gray-500">Description</div>
                                  <div className="text-sm text-gray-800">{item.description || "no data"}</div>
                                </div>
                              </div>
                            ))}
                          </div>
                        </div>
                      )}
                    </div>
                  </td>
                </tr>
              )}
            </React.Fragment>
          );
        })}
      </tbody>
    </table>
  </>
)}
        </>
      )}
    </div>
  );
};

export default Index;